import initialState from '../state'

export const SET_HEADERS = 'export-tool/headers/set-headers'

export default function reducer(state = {...initialState.headers}, action = {}) {
  switch (action.type) {
    case SET_HEADERS:
      return action.payload.headers
      break

    default:
      return state
      break
  }
}

export function setHeaders(headers) {
  return {
    type: SET_HEADERS,
    payload: {
      headers
    }
  }
}




// WEBPACK FOOTER //
// ./ducks/headers.js